import { Fragment } from "react";
import { parseInline } from "./inline-parser.js";
import "./inline-content.css";

function InlineNodes(props) {
    return (
        <>
            {props.Nodes.map((node, index) => {
                switch (node.type) {
                    case "bold":
                        return (
                            <strong key={index} className="eone-help-bold">
                                <InlineNodes Nodes={node.children} />
                            </strong>
                        );
                    case "link":
                        if (node.href.startsWith("help.")) {
                            return (
                                <span key={index} className="link-blue-green cursor">
                                    <InlineNodes Nodes={node.children} />
                                </span>
                            );
                        }
                        return (
                            <a key={index} href={node.href} className="link-blue-green cursor" target="blank">
                                <InlineNodes Nodes={node.children} />
                            </a>
                        );
                    default:
                        return <Fragment key={index}>{node.value}</Fragment>;
                }
            })}
        </>
    );
}

export function renderInlineContent(value) {
    const nodes = parseInline(value);
    if (nodes.length === 0) return null;
    return <InlineNodes Nodes={nodes} />;
}
